export const appTranslations = {
  en: () => import('./en.json').then(translations => ({ en: translations.default })),
  de: () => import('./de.json').then(translations => ({ de: translations.default })),
  fr: () => import('./fr.json').then(translations => ({ fr: translations.default })),
  nl: () => import('./nl.json').then(translations => ({ nl: translations.default })),
  fi: () => import('./fi.json').then(translations => ({ fi: translations.default })),
};

export const uiTranslations = {
  en: () =>
    import(/* webpackPrefetch: true */ '@recruitee/user-interface/locales/en.json').then(
      translations => ({
        en: translations.default,
      }),
    ),
  de: () =>
    import('@recruitee/user-interface/locales/de.json').then(translations => ({
      de: translations.default,
    })),
  fr: () =>
    import('@recruitee/user-interface/locales/fr.json').then(translations => ({
      fr: translations.default,
    })),
  nl: () =>
    import('@recruitee/user-interface/locales/nl.json').then(translations => ({
      nl: translations.default,
    })),
  fi: () =>
    import('@recruitee/user-interface/locales/fi.json').then(translations => ({
      fi: translations.default,
    })),
};
